import type { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { WorkOrderSeasonData } from 'gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { gqlWorkOrderSeasons } from '../workOrderQueries';

export const useSeasons = (workOrderId: number, withEffect = true, requestId = 'workOrderSeasons') => {
    const dispatch = useDispatch();

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [seasonsResponse, seasonsResponseStatus, seasonsResponseError, seasonsRequest] = useRequest({
        requestId,
        query: gqlWorkOrderSeasons,
        variables,
        withEffect,
    });

    const refreshSeasonsData = useCallback(() => {
        dispatch(seasonsRequest(variables));
    }, [dispatch, seasonsRequest, variables]);

    return useMemo<[WorkOrderSeasonData[], RequestStatus, any, () => void]>(
        () => [
            seasonsResponse?.uerWorkOrderSeasons?.items ?? [],
            seasonsResponseStatus,
            seasonsResponseError,
            refreshSeasonsData,
        ],
        [refreshSeasonsData, seasonsResponse?.uerWorkOrderSeasons?.items, seasonsResponseError, seasonsResponseStatus],
    );
};
